import React, { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"

import { useMediaQuery } from "react-responsive"
import { BadgeMobile } from "../ui/base/badge/Badge"
import { ScrollToTop } from "../ui/base/ScrollToTop"
import { Footer } from "../ui/blocks/Footer"
import { Header } from "../ui/blocks/Header"
import ReviewSection from "../ui/blocks/ReviewSection/ReviewSection"
import ScrollMotionInstructor from "../ui/blocks/ScrollMotionInstructor/ScrollMotionInstructor"
import VideoInstructor from "../ui/blocks/videoInstructor"
import InfoInstructor from "./../ui/blocks/InfoInstructor/InfoInstructor"
const InstructorPage = () => {
  const [headColor, setHeadColor] = useState("white")
  const [headSolid, setHeadSolid] = useState(false)
  const [bottomShow, setBottomShow] = useState(false)
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" })

  const {
    ref: inViewRef,
    inView,
    entry,
  } = useInView({
    /* Optional options */
    threshold: 0.15,
    triggerOnce: true,
  })

  useEffect(() => {
    if (window.innerWidth > 768) {
      window.scrollTo(0, 0)
    } else {
      setBottomShow(true)
    }
  }, [bottomShow])

  return (
    <ScrollToTop>
      <Header color={headColor} solid={headSolid} />
      <ScrollMotionInstructor
        setHeadColor={setHeadColor}
        setHeadSolid={setHeadSolid}
        setBottomShow={setBottomShow}
        hideScrollHint={inView}
      />
      {bottomShow ? (
        <>
          <VideoInstructor ref={inViewRef} />
          <InfoInstructor />
          <BadgeMobile />
          <ReviewSection />
          {/* <AppRoot showHeader={false} autoHeight={isMobile}>
            <AccountInstructor />
          </AppRoot> */}
          <Footer />
        </>
      ) : (
        ""
      )}
    </ScrollToTop>
  )
}

export default InstructorPage
